import { ProductHit } from '@app-types/product-hit.types'
import { mapSearchHitToProductHit } from '@app-domains/meilisearch/mappers/product-hit.mapper'
import { InstantSearchSearchResult } from '@app-domains/meilisearch/mappers/instantsearch-response.mapper'
import { ProductSearchResult } from '@app-domains/meilisearch/types/product-search.types'

type InstantSearchFacets = Record<string, Record<string, number>>
type InstantSearchFacetStats = Record<string, { min: number; max: number; avg?: number; sum?: number }>

export function mapProductSearchResult(
    result: ProductSearchResult,
    indexName: string,
    query: string,
): InstantSearchSearchResult<ProductHit> {
    return {
        hits: result.hits.map(mapSearchHitToProductHit),
        nbHits: result.totalHits,
        page: result.page - 1,
        nbPages: result.totalPages,
        hitsPerPage: result.perPage,
        processingTimeMS: result.processingTimeMs,
        exhaustiveNbHits: true,
        exhaustiveFacetsCount: true,
        query,
        params: '',
        index: indexName,
        facets: mapFacets(result.facets),
        facets_stats: mapFacetStats(result.facetStats),
    }
}

function mapFacets(facets: ProductSearchResult['facets']): InstantSearchFacets {
    const result: InstantSearchFacets = {}
    for (const facet of facets) {
        result[facet.attribute] = facet.values.reduce<Record<string, number>>((acc, item) => {
            acc[item.value] = item.count
            return acc
        }, {})
    }
    return result
}

function mapFacetStats(facetStats: ProductSearchResult['facetStats']): InstantSearchFacetStats {
    const result: InstantSearchFacetStats = {}
    for (const stat of facetStats) {
        if (stat.min == null || stat.max == null) continue
        result[stat.attribute] = { min: stat.min, max: stat.max }
    }
    return result
}
